var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarehouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.15185 6.25C2.11632 6.25 1.27686 7.08947 1.27686 8.125C1.27686 9.16053 2.11632 10 3.15185 10H9.375C10.4105 10 11.25 9.16053 11.25 8.125C11.25 7.08947 10.4105 6.25 9.375 6.25H3.15185ZM18.125 6.25C17.0895 6.25 16.25 7.08947 16.25 8.125C16.25 9.16053 17.0895 10 18.125 10H74.9731V13.75H3.75C2.365 13.75 1.25 14.865 1.25 16.25V21.25C1.25 22.635 2.365 23.75 3.75 23.75H5V70H3.15186C2.11632 70 1.27686 70.8395 1.27686 71.875C1.27686 72.9105 2.11632 73.75 3.15186 73.75H58.75C60.135 73.75 61.25 72.635 61.25 71.25V58.75C61.25 57.365 60.135 56.25 58.75 56.25H53.75V60C53.75 60.6925 53.1925 61.25 52.5 61.25H50C49.3075 61.25 48.75 60.6925 48.75 60V56.25H43.75C42.365 56.25 41.25 57.365 41.25 58.75V70H38.75V58.75C38.75 57.365 37.635 56.25 36.25 56.25H31.25V60C31.25 60.6925 30.6925 61.25 30 61.25H27.5C26.8075 61.25 26.25 60.6925 26.25 60V56.25H21.25C19.865 56.25 18.75 57.365 18.75 58.75V70H15V41.25H38.125V44.3896C37.3699 44.9601 36.875 45.8557 36.875 46.875C36.875 48.6009 38.2741 50 40 50C41.7259 50 43.125 48.6009 43.125 46.875C43.125 45.8557 42.6301 44.9601 41.875 44.3896V41.25H66.875C67.9105 41.2499 68.7499 40.4105 68.75 39.375V23.75H71.25V70H68.75V48.125C68.75 47.0895 67.9105 46.25 66.875 46.25C65.8395 46.25 65 47.0895 65 48.125V71.875C65.0001 72.9105 65.8395 73.7499 66.875 73.75H76.8481C77.8837 73.75 78.7231 72.9105 78.7231 71.875C78.7231 70.8395 77.8837 70 76.8481 70H75V23.75H76.25C77.635 23.75 78.75 22.635 78.75 21.25L78.7231 8.125C78.723 7.08951 77.8836 6.2501 76.8481 6.25H18.125ZM8.75 23.75H65V28.75H60.625C59.5895 28.75 58.75 29.5895 58.75 30.625C58.75 31.6605 59.5895 32.5 60.625 32.5H65V37.5H15V32.5H53.125C54.1605 32.5 55 31.6605 55 30.625C55 29.5895 54.1605 28.75 53.125 28.75H13.125C12.0895 28.7501 11.2501 29.5895 11.25 30.625V70H8.75V23.75Z",
    fill: "url(#paint0_linear_387_3470)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_387_3470",
    x1: 79.7543,
    y1: 7.27583,
    x2: 11.7744,
    y2: 83.1761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F45634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504,
    stopColor: "#9D2161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E1C49"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehouse);
export default __webpack_public_path__ + "static/media/warehouse.0b4956d22404f5672183c8bfe8eec11c.svg";
export { ForwardRef as ReactComponent };